module.exports = __webpack_public_path__ + "img/智能全语音门户.e4708c3c.jpg";